export class MilstonePaymentConfirmation {
    ApplicantId: string;
    order_id: string;
    Name: string;
    mer_amount: string;
    AmountInWords: string;
    Description: string;
    payment_mode: string;
    CreatedOn: Date;
    card_name: string;
    EmailId: string;
    MobileNo: string;
    PdfContent: string;  
    IsTotalPaid: boolean;
}